import {CollisionDescriptor, CollisionDetection} from '@dnd-kit/core';

/**
 * Returns the rectangles that the pointer is hovering over (vertically)
 */
const pointerWithinVertical: CollisionDetection = ({
    active,
    droppableContainers,
    droppableRects,
    pointerCoordinates,
}) => {
    if (!pointerCoordinates) {
        return [];
    }

    const activeRect = droppableRects.get(active.id);
    if (activeRect === undefined) return [];

    const collisions: CollisionDescriptor[] = [];
    droppableContainers.forEach((droppableContainer) => {
        const {id} = droppableContainer;
        const rect = droppableRects.get(id);
        const pointerY = pointerCoordinates.y;

        if (rect === undefined) return;

        const activeYCenter = activeRect.top + activeRect.height / 2;

        const isAboveActive = activeYCenter > rect.bottom;
        const isBelowActive = activeYCenter < rect.top;

        if (isAboveActive) {
            const distance = rect.bottom - pointerY;
            if (distance > 0)
                collisions.push({
                    data: {
                        droppableContainer,
                        value: distance,
                    },
                    id,
                });
        }

        if (isBelowActive) {
            const distance = pointerY - rect.top;
            if (distance > 0)
                collisions.push({
                    data: {
                        droppableContainer,
                        value: distance,
                    },
                    id,
                });
        }
    });

    if (collisions.length === 0) {
        const activeContainer = droppableContainers.find(
            (container) => container.id === active.id,
        );
        if (activeContainer)
            collisions.push({
                data: {
                    droppableContainer: activeContainer,
                    value: 0,
                },
                id: active.id,
            });
    }

    return collisions.sort(
        (
            {data: {value: a}}: CollisionDescriptor,
            {data: {value: b}}: CollisionDescriptor,
        ) => a - b,
    );
};

export default pointerWithinVertical;
